import styleInject from 'style-inject';
import { collectStyles } from '@lsg/ssr';

var reactStyles = " .lsgs-MS4xNC4w--picture-background{display:block;height:100%;background-repeat:no-repeat;background-size:cover;} .lsgs-MS4xNC4w--picture-background:not(.lsgs-MS4xNC4w--no-margin){margin-bottom:16px;}@media screen and (min-width:1024px){ .lsgs-MS4xNC4w--picture-background:not(.lsgs-MS4xNC4w--no-margin){margin-bottom:24px;}} .lsgs-MS4xNC4w--picture-background.lsgs-MS4xNC4w--picture-background__inline{display:inline-block;}";
var hostClass = "lsgs-MS4xNC4w--picture-background";
styleInject(reactStyles);
collectStyles(reactStyles);

export { hostClass, reactStyles };
